/* eslint-disable i18next/no-literal-string */
import { useSyncExternalStore } from "react";
import DiagnosticsStore from "@/features/diagnostics/store/diagnostics-store.ts";
import { typedObjectEntries } from "@/utils/types.ts";
import { DiagnosticsEmpty, DiagnosticsGrid } from "../lib/diagnostics-card.tsx";
import GlobalsItem from "./globals-item.tsx";

export default function GlobalsList() {
    const globals = useSyncExternalStore(DiagnosticsStore.subscribe, () => DiagnosticsStore.globals);

    if (!globals) {
        return <DiagnosticsEmpty>No globals set!</DiagnosticsEmpty>;
    }

    return (
        <DiagnosticsGrid size="sm">
            {typedObjectEntries(globals).map(([key, value]) => (
                <GlobalsItem key={key} global={key} value={value ?? null} />
            ))}
        </DiagnosticsGrid>
    );
}
